import { action, createRequestTypes } from '../base';

export const priceListActionTypes = {
  GET_PRICE_LISTS: createRequestTypes('GET_PRICE_LISTS'),
  GET_APPLY_PRICE_LISTS: createRequestTypes('GET_APPLY_PRICE_LISTS'),
  GET_PRICE_LIST_BY_ID: createRequestTypes('GET_PRICE_LIST_BY_ID'),
  CREATE_PRICE_LIST: createRequestTypes('CREATE_PRICE_LIST'),
  UPDATE_PRICE_LIST: createRequestTypes('UPDATE_PRICE_LIST'),
  UPDATE_STATUS_PRICE_LIST: createRequestTypes('UPDATE_STATUS_PRICE_LIST'),
  DELETE_PRICE_LIST: createRequestTypes('DELETE_PRICE_LIST'),
  GET_CUSTOM_PRICE_LIST: createRequestTypes('GET_CUSTOM_PRICE_LIST'),
  GET_EXISTING_PRICE_LIST: createRequestTypes('GET_EXISTING_PRICE_LIST'),
};

class PriceListActions {
  /**
   * @param {*} tenantId
   * @param {*} priceListId
   * @param {*} isListScreen
   * @param {*} screenType
   * @param {*} customerId
   * @param {*} states
   * @param {*} page
   * @param {*} limit
   * @param {*} status
   * @param searchKeyword
   * @return
   */
     getPriceLists = (tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword) => action(priceListActionTypes.GET_PRICE_LISTS.REQUEST, {
       tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword,
     })

     /**
     *
     * @param {*} getPriceListsLoading
     * @return
     */
     getPriceListsLoading = (getPriceListsLoading) => action(priceListActionTypes.GET_PRICE_LISTS.LOADING, {
       getPriceListsLoading,
     })

     /**
      * @return
      * @param priceLists
      * @param customFields
      */
     getPriceListsSuccess = (priceLists) => action(priceListActionTypes.GET_PRICE_LISTS.SUCCESS, {
       priceLists,
     })

     /**
   * @param {*} tenantId
   * @param {*} priceListId
   * @param {*} screenType
   * @param {*} customerId
   * @param {*} states
   * @param {*} skuId
   * @return
   */
     getApplyPriceLists = (tenantId, priceListId, customerId, states, skuId, callback) => action(priceListActionTypes.GET_APPLY_PRICE_LISTS.REQUEST, {
       tenantId, priceListId, customerId, states, skuId, callback,
     })

    /**
    *
    * @param {*} getApplyPriceListsLoading
    * @return
    */
    getApplyPriceListsLoading = (getApplyPriceListsLoading) => action(priceListActionTypes.GET_APPLY_PRICE_LISTS.LOADING, {
      getApplyPriceListsLoading,
    })

    /**
     * @return
     * @param applyPriceLists
     */
    getApplyPriceListsSuccess = (applyPriceLists) => action(priceListActionTypes.GET_APPLY_PRICE_LISTS.SUCCESS, {
      applyPriceLists,
    })

     /**
      * @param {*} tenantId
      * @param {*} plpriceListI
      * @return
      */
     getPriceListById = (tenantId, priceListId, isListScreen, callback) => action(priceListActionTypes.GET_PRICE_LIST_BY_ID.REQUEST, {
       tenantId, priceListId, isListScreen, callback,
     })

     /**
      *
      * @param {*} getPriceListByIdLoading
      * @return
      */
     getPriceListByIdLoading = (getPriceListByIdLoading) => action(priceListActionTypes.GET_PRICE_LIST_BY_ID.LOADING, {
       getPriceListByIdLoading,
     })

     /**
      * @return
      * @param selectedPriceList
      * @param soData
      */
      getPriceListByIdSuccess = (selectedPriceList) => action(priceListActionTypes.GET_PRICE_LIST_BY_ID.SUCCESS, {
        selectedPriceList,
      })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
    createPriceList = (payload, callback) => action(priceListActionTypes.CREATE_PRICE_LIST.REQUEST, {
      payload,
      callback,
    })

    /**
     *
     * @param {*} createPriceListLoading
     * @return
     */
    createPriceListLoading = (createPriceListLoading) => action(priceListActionTypes.CREATE_PRICE_LIST.LOADING, {
      createPriceListLoading,
    })

    /**
     *
     * @param {*} payload
     * @param {*} callback
     * @return
     */
     updatePriceList = (payload, callback) => action(priceListActionTypes.UPDATE_PRICE_LIST.REQUEST, {
       payload,
       callback,
     })

     /**
      *
      * @param {*} updatePriceListLoading
      * @return
      */
     updatePriceListLoading = (updatePriceListLoading) => action(priceListActionTypes.UPDATE_PRICE_LIST.LOADING, {
       updatePriceListLoading,
     })

    /**
     * @param tenantId
     * @param soId
     * @param orgId
     * @param payload
     * @param callback
     * @return {{type: *}}
     */
    updatePriceListStatus = (payload, callback) => action(priceListActionTypes.UPDATE_STATUS_PRICE_LIST.REQUEST, {
      payload, callback,
    })

    /**
     * @param updatePriceListStatusLoading
     * @param deletePriceListLoading
     * @return {{type: *}}
     */
     updatePriceListStatusLoading = (updatePriceListStatusLoading) => action(priceListActionTypes.UPDATE_STATUS_PRICE_LIST.LOADING, {
       updatePriceListStatusLoading,
     })

     /**
      * @param payload
      * @param callback
      * @return {{type: *}}
      */
      deletePriceList = (payload, callback) => action(priceListActionTypes.DELETE_PRICE_LIST.REQUEST, {
        payload, callback,
      })

      /**
       * @param deletePriceListLoading
       * @return {{type: *}}
       */
       deletePriceListLoading = (deletePriceListLoading) => action(priceListActionTypes.DELETE_PRICE_LIST.LOADING, {
         deletePriceListLoading,
       })

       /**
   *
   * @return
   */
  getCustomPriceList = (orgId, sampleType) => action(priceListActionTypes.GET_CUSTOM_PRICE_LIST.REQUEST, {
    orgId, sampleType,
  });

  /**
      *
      * @param {*} getCustomPriceListLoading
      * @return
      */
      getCustomPriceListLoading = (getCustomPriceListLoading) => action(
        priceListActionTypes.GET_CUSTOM_PRICE_LIST.LOADING, {
          getCustomPriceListLoading,
        },
      );

      /**
       * @param customPriceList
       * @return
       */
      getCustomPriceListSuccess = (customPriceList) => action(
        priceListActionTypes.GET_CUSTOM_PRICE_LIST.SUCCESS, {
          customPriceList,
        },
      );

    /**
   *
   * @return
   */
    getExistingPriceList = (orgId, priceListId, includeOtherProducts) => action(priceListActionTypes.GET_EXISTING_PRICE_LIST.REQUEST, {
      orgId, priceListId, includeOtherProducts,
    });

    /**
    *
    * @param {*} getExistingPriceListLoading
    * @return
    */
    getExistingPriceListLoading = (getExistingPriceListLoading) => action(
      priceListActionTypes.GET_EXISTING_PRICE_LIST.LOADING, {
        getExistingPriceListLoading,
      },
    );

    /**
     * @param existingPriceList
     * @return
     */
    getExistingPriceListSuccess = (existingPriceList) => action(
      priceListActionTypes.GET_EXISTING_PRICE_LIST.SUCCESS, {
        existingPriceList,
      },
    );
}

export default new PriceListActions();
